<template>
    <Row class="page4">
        <Col :span="12" style="padding:0 1%;">
        <div class="left">
            <span class='title'><span class="title-gradient" >传感器数据详情</span></span>
            <span class="angle1"></span>
            <span class="angle2"></span>
            <span class="angle3"></span>
            <span class="angle4"></span>
            <div class="left1">
                <el-table class="tale" :data="Data1" height="100%"
                    style="width: 95%; background-color: #151456; color: #fff;"
                    header-cell-style="background-color: #151456; font-size: 15px ;color: #fff; textAlign: center"
                    cell-style="background-color: #151456; border:0;">
                    <el-table-column prop="name" label="设备名称" width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="cid" label="所在位置" width="140" align="center">
                    </el-table-column>
                    <el-table-column prop="companyName" label="公司名称" align="center">
                    </el-table-column>
                    <el-table-column prop="status" label="工作状态" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status === 1" class="dot green"></div>
                            <div v-else-if="scope.row.status === 0" class="dot red"></div>
                            <div v-else-if="scope.row.status === 2" class="dot orange"></div>
                            <div v-else-if="scope.row.status === 3" class="dot gray"></div>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="padding: 10px 0">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="pageNum" :page-sizes="[5, 10, 15, 20]" :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        </Col>
        <Col :span="12">
        <div class="right-1">
            <div class="right1-1">
                <span class='title'><span class="title-gradient" >其余设备详情</span></span>
                <span class="angle1"></span>
                <span class="angle2"></span>
                <span class="angle3"></span>
                <span class="angle4"></span>
                <div class="right1-2" style="margin-right: 5%;">
                    <el-table class="talbe" v-if="Data1.length > 0" :data="Data2" height="100%"
                        style="width: 100%; background-color: #151456; color: #fff;"
                        header-cell-style="background-color: #151456; font-size: 15px ;color: #FFF"
                        cell-style="background-color: #151456; border:0">
                        <el-table-column prop="name" label="设备名称" width="170">
                        </el-table-column>
                        <el-table-column prop="companyName" label="公司名称" width="170">
                        </el-table-column>
                        <el-table-column prop="cid" label="所在位置">
                        </el-table-column>
                        <el-table-column prop="status" label="工作状态" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.work === false" class="dot red"></div>
                                <div v-else-if="parseInt(scope.row.status) === 1" class="dot green"></div>
                                <div v-else-if="parseInt(scope.row.status) === 2" class="dot orange"></div>
                                <div v-else-if="parseInt(scope.row.status) === 0" class="dot red"></div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-switch v-model="scope.row.status" active-value="1" inactive-value="0"
                                    active-color="#13ce66" inactive-color="#ff4949"
                                    :disabled="isSwitchDisabled(scope.row)" @change="handleSwitchChange(scope.row)">
                                </el-switch>
                            </template>
                        </el-table-column>

                    </el-table>
                </div>
            </div>
        </div>
        </Col>
    </Row>
</template>

<script>

    export default {
        name: 'page4',
        components: {
        },
        props: {
            comid: {
                type: Number
            }
        },
        data() {
            return {
                Data1: [],
                Data2: [],
                resizeFn: null,
                value: true,
                pageNum: 1,
                pageSize: 10,
                total: 0,
                user: localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{},
                // comid :(localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):{}).companyid
            }
        },
        mounted() {
            if(this.user.role ==="超级管理员"){
                this.setData(this.comid)
            }else{
                 this.setData(this.user.companyid)
            }
        },
        beforeDestroy() {
            // window.removeEventListener('resize', this.resizeFn)
        },
        methods: {
            setData(comid) {
                console.log(this.comid);
                this.request.get('/api/equipment/getEquitmentByComid', {
                    params: {
                        comid: comid,
                        issensor: 1,
                        pageNum: this.pageNum,
                        pageSize: this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.code === "200" && res.data) {
                            this.Data1 = res.data.records;
                            this.total = res.data.total
                            console.log('111',this.Data1);
                            // 将数据放入 Data1 中
                        } else {
                            console.error('请求失败:', res.msg);
                        }
                    })
                this.request.get('/api/equipment/getEquitmentByComid', {
                    params: {
                        comid: comid,
                        issensor: 0,
                        // pageNum: this.pageNum,
                        // pageSize: this.pageSize,
                    }  // 传递 pondsid 参数
                })
                    .then(res => {
                        if (res.code === "200" && res.data) {
                            this.Data2 = res.data;
                            console.log(this.Data2);
                            // 将数据放入 Data1 中
                        } else {
                            this.Data2 = []
                            console.error('请求失败:', res.msg);
                        }
                    })
            },
            isSwitchDisabled(row) {
                if (row.status === 2 || row.status === 3) {
                    row.iswork = false;
                    return true
                }
                return false;
            },
            handleSwitchChange(row) {
                // 提取开关状态和设备 ID
                const Switch = row.status; // 1 表示开启，0 表示关闭
                const pid = row.nickname; // 使用 nickname 作为设备 ID
                console.log(Switch)

                // 发送请求到后端
                this.request.post('/api/equipment/setwitch', null, {

                    params: {
                        Switch: String(Switch), // 确保为字符串
                        pid: String(pid)        // 确保为字符串
                    }

                })
                    .then(res => {
                        if (res.code === "200") {
                            this.$message.success('设置成功');
                            console.log('work:', row.work, 'status:', row.status);
                        } else {
                            // 如果设置失败，恢复原状态
                            row.status = Switch === 1 ? 0 : 1;
                            this.$message.error('设置失败: ' + res.msg);
                        }
                    })
                    .catch(err => {
                        // 处理请求异常
                        // row.status = Switch === 1 ? 0 : 1;
                        console.error('请求错误:', err);
                        this.$message.error('设置失败，请重试');
                    });
            },
            handleSizeChange(pageSize) {
                this.pageSize = pageSize
                if(this.user.role ==="超级管理员"){
                this.setData(this.comid)
            }else{this.setData(this.user.companyid)}
            },
            handleCurrentChange(pageNum) {
                this.pageNum = pageNum
                if(this.user.role ==="超级管理员"){
                this.setData(this.comid)
            }else{this.setData(this.user.companyid)}
            
            }
        },
        computed: {

        },
        watch: {
            comid(val) {
                this.setData(val);
            }
        },
    }
</script>

<style lang="less" scoped>
::v-deep .el-pagination__total,
::v-deep .el-pagination__jump {
  color: #fff !important;
}

    .page4 {
        height: 100%;
        width: 100%;
        padding: 14px 20px 20px;
        background: #03044A;
        overflow: hidden;

        .ivu-col {
            height: 100%;
        }

        .left,
        .right1-1,
        .center-bottom {
            height: 100%;
            border: 1px solid #0D2451;
            position: relative;
            background: #151456;

            .left1,
            .right1-2 {
                border-bottom: 1px solid #0D2451;
                background: #151456;
                height: 90%;
                margin-top: 5%;
                margin-left: 5%;

                .dot {
                    width: 10px;
                    height: 10px;
                    border-radius: 50%;
                    display: inline-block;
                    margin: 0 auto;
                    /* 水平居中 */
                }

                .green {
                    background-color: green;
                }

                .red {
                    background-color: red;
                }

                .orange {
                    background-color: orange;
                }

                .gray {
                    background-color: gray;
                }
            }

            .title {
                position: absolute;
                display: inline-block;
                color: #fff;
                /* border: 2px solid #6EDDF1; */
                height: 18px;
                /* padding: 0 2px; */
                left: 50%;
                transform: translate(-50%, -50%);

                .title-text {
                    position: relative;
                    font-size: 16px;
                    background: #09102E;
                    display: inline-block;
                    padding: 0 4px;
                    transform: translateY(-5px);
                }
            }
        }

        .right-1 {
            height: 100%;

            .right1-1 {
                height: 100%;
            }

            ;

        }

        .el-table_row {
            border-bottom: 0px;
        }

        .table .el-table_row {
            height: 100px;
        }

    }
</style>